import { Action, combineReducers } from '@reduxjs/toolkit';

import { agentsApi } from '../rest/agentsApi';
import { chatsApi } from '../rest/chatsApi';
import { threadsApi } from '../rest/threadsApi';
import { authApi } from '../rest/authApi';
import { chatbotsApi } from '../rest/chatbots';
import { configApi } from '../rest/configApi';
import { credentialApi } from '../rest/credentialApi';
import { customersApi } from '../rest/customersApi';
import { paymentApi } from '../rest/paymentApi';
import { statisticApi } from '../rest/statisticApi';
import { userApi } from '../rest/userApi';
import { utilitiesApi } from '../rest/utilities';
import { workflowHistoryApi } from '../rest/workflowHistoryApi';

import { IAgentsReducer, agentsSlice } from './agents';
import { IAuthReducer, authSlice } from './auth';
import { IChatsReducer, chatsSlice } from './chats';
import { ICredentialsReducer, credentialsSlice } from './credentials';
import { ICustomersReducer, customersSlice } from './customers';
import { IUiReducer, uiSlice } from './ui';
import { IUsersReducer, usersSlice } from './users';

export interface StoreState {
  auth: IAuthReducer;
  customers: ICustomersReducer;
  users: IUsersReducer;
  agents: IAgentsReducer;
  credentials: ICredentialsReducer;
  chats: IChatsReducer;
  ui: IUiReducer;
}

export const combinedReducers = combineReducers({
  [authSlice.name]: authSlice.reducer,
  [customersSlice.name]: customersSlice.reducer,
  [usersSlice.name]: usersSlice.reducer,
  [agentsSlice.name]: agentsSlice.reducer,
  [credentialsSlice.name]: credentialsSlice.reducer,
  [chatsSlice.name]: chatsSlice.reducer,
  [uiSlice.name]: uiSlice.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [customersApi.reducerPath]: customersApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [credentialApi.reducerPath]: credentialApi.reducer,
  [agentsApi.reducerPath]: agentsApi.reducer,
  [chatsApi.reducerPath]: chatsApi.reducer,
  [threadsApi.reducerPath]: threadsApi.reducer,
  [utilitiesApi.reducerPath]: utilitiesApi.reducer,
  [statisticApi.reducerPath]: statisticApi.reducer,
  [paymentApi.reducerPath]: paymentApi.reducer,
  [configApi.reducerPath]: configApi.reducer,
  [chatbotsApi.reducerPath]: chatbotsApi.reducer,
  [workflowHistoryApi.reducerPath]: workflowHistoryApi.reducer,
});

export type Store = ReturnType<typeof combinedReducers>;

const rootReducer = (state: Store, action: Action) => combinedReducers(state, action);

export default rootReducer;
